import { render, staticRenderFns } from "./EmployeePTPayrollView.vue?vue&type=template&id=33ac4e53&scoped=true"
import script from "./EmployeePTPayrollView.vue?vue&type=script&lang=js"
export * from "./EmployeePTPayrollView.vue?vue&type=script&lang=js"
import style0 from "./EmployeePTPayrollView.vue?vue&type=style&index=0&id=33ac4e53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ac4e53",
  null
  
)

export default component.exports